import { Action } from '@ngrx/store';
import * as underWritingDataResultAction from '../actions/underwriting-ho.action';


export type Actions = underWritingDataResultAction.Actions;

export function UnderWritingDataReducer(state: any[] = [],
    action: underWritingDataResultAction.Actions) {
    switch (action.type) {
        case underWritingDataResultAction.ADD_UNDERWRITING_HO:
            return [...state, action.payload];

        // Add this case:
        case underWritingDataResultAction.REMOVE_UNDERWRITING_HO:
            return [...state].splice(action.payload, 1);
        default:
            return state;
    }
}

